import { useContext } from 'react'
import { Responsive as SemanticResponsive } from 'semantic-ui-react'
import InitialPropsContext from '../InitialPropsContext/InitialPropsContext'

interface OnlyMobileContainerProps {
  children: JSX.Element[] | JSX.Element
  platform: ValidPlatform
  minWidth?: number
  maxWidth?: number
}

type ValidPlatform = 'desktop' | 'mobile'

export const Responsive = ({
  children,
  platform,
  minWidth,
  maxWidth
}: OnlyMobileContainerProps) => {
  const { windowWidth } = useContext(InitialPropsContext)

  return (
    <SemanticResponsive
      fireOnMount
      getWidth={() => getCurrentWindowWidth(windowWidth)}
      minWidth={minWidth}
      maxWidth={maxWidth}
      {...widthFactory(platform)}
    >
      {children}
    </SemanticResponsive>
  )
}

const widthFactory = (targetPlatform: ValidPlatform) => {
  switch (targetPlatform) {
    case 'mobile':
      return {
        maxWidth: SemanticResponsive.onlyMobile.maxWidth
      }
    case 'desktop':
      return {
        minWidth: SemanticResponsive.onlyTablet.minWidth
      }
    default:
      return {}
  }
}

const getCurrentWindowWidth = (windowWidth: number) => {
  if (typeof window !== 'undefined') {
    return window.innerWidth
  }

  return windowWidth
}
